import { createContext, useContext } from 'react';

export type ToastTone = 'neutral' | 'success' | 'error';

export interface ToastOptions {
  message: string;
  tone?: ToastTone;
  action?: { label: string; onClick: () => void };
  /** ms; default 4000, 6000 with an action; errors persist until dismissed. */
  duration?: number;
  /** Called when the toast goes away without its action being used (e.g. Undo window ended). */
  onExpire?: () => void;
}

export type ShowToast = (options: ToastOptions | string) => void;

export const ToastContext = createContext<ShowToast | null>(null);

export function useToast(): ShowToast {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
  return ctx;
}
